import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostObjektArtCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostObjektArtCommandService],
  exports: []
})
export class PostObjektArtCommandServiceModule { }
